import naja from "naja";

export default class Notification {
    private static notificationParentId = 'notifications';
    private static timeout = 5000; // 5 sekund

    public static init(): void {
        const parent = document.getElementById(this.notificationParentId);
        if (!parent) return;

        // Najdi všechny potomky s role="alert" (jednotlivé notifikace)
        const alerts = parent.querySelectorAll<HTMLElement>('[role="alert"]');
        alerts.forEach((alert) => {
            setTimeout(() => {
                alert.classList.add('notification--hide');
                // Po animaci (nebo hned) odeber z DOM
                alert.addEventListener(
                    'transitionend',
                    () => {
                        alert.remove();
                    },
                    { once: true },
                );
            }, this.timeout);
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--ajaxNotification') {
                this.init();
            }
        });
    }
}
